/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Gray_Bat_CookInputs */

const en_bright_gray_bat_cook = /** @type {(inputs: Bright_Gray_Bat_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage topics that drive AI comment classification. Default topics are always included. Topics can be organized into groups — within a group, topics are mutually exclusive by default (each comment gets at most one topic). Enable multi-label to allow multiple topics from the same group.`)
};

const de_bright_gray_bat_cook = /** @type {(inputs: Bright_Gray_Bat_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themen verwalten, die die KI-Kommentarklassifizierung steuern. Standardthemen sind immer enthalten. Themen können in Gruppen organisiert werden — innerhalb einer Gruppe sind Themen standardmäßig exklusiv (jeder Kommentar erhält höchstens ein Thema). Aktivieren Sie Multi-Label, um mehrere Themen derselben Gruppe zuzulassen.`)
};

/**
* | output |
* | --- |
* | "Manage topics that drive AI comment classification. Default topics are always included. Topics can be organized into groups — within a group, topics are mutu..." |
*
* @param {Bright_Gray_Bat_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_gray_bat_cook = /** @type {((inputs?: Bright_Gray_Bat_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Gray_Bat_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_gray_bat_cook(inputs)
	return de_bright_gray_bat_cook(inputs)
});